import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { IoNotifications, IoClose } from 'react-icons/io5';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../firebase';
import { useUser } from '../context/UserContext';
import './PushNotifications.css';

export default function PushNotifications() {
  const { user } = useUser();
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    if (!user) return;
    // Déjà répondu (Firestore)
    if (user.pushDismissed) return;
    // Déjà répondu (localStorage fallback)
    const dismissed = localStorage.getItem('plumly_push_dismissed');
    if (dismissed) return;
    // Navigateur ne supporte pas les notifs
    if (!('Notification' in window)) return;
    // Déjà accepté ou refusé via le navigateur
    if (Notification.permission !== 'default') return;

    setTimeout(() => setShowBanner(true), 5000);
  }, [user]);

  const markDismissed = async () => {
    localStorage.setItem('plumly_push_dismissed', 'true');
    if (user) {
      try {
        await updateDoc(doc(db, 'users', user.id), { pushDismissed: true });
      } catch (e) {
        console.warn('Erreur sauvegarde push:', e);
      }
    }
  };

  const handleEnable = async () => {
    const permission = await Notification.requestPermission();
    if (permission === 'granted') {
      new Notification('🪶 Plumly', {
        body: 'Notifications activées ! Tu seras prévenu des nouveaux chapitres.',
        icon: '/logo192.png',
      });
    }
    setShowBanner(false);
    markDismissed();
  };

  const handleDismiss = () => {
    setShowBanner(false);
    markDismissed();
  };

  if (!showBanner) return null;

  return (
    <motion.div
      className="push-banner"
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 50 }}
    >
      <IoNotifications className="push-icon" />
      <div className="push-info">
        <p className="push-title">Reste informé !</p>
        <p className="push-text">Active les notifications pour les nouveaux chapitres et messages.</p>
      </div>
      <motion.button className="push-enable" onClick={handleEnable} whileTap={{ scale: 0.95 }}>
        Activer
      </motion.button>
      <button className="push-close" onClick={handleDismiss}><IoClose /></button>
    </motion.div>
  );
}